import React from 'react'
import SpinnerUI from '../../widgets/output/SpinnerUI'
import './SpinnerComponent.css'

const SpinnerComponentUI = ({context}) =>
  <div className='com_spinner g_flex_v'>
    <SpinnerUI show={true} dimension='w80' />
  </div>

export default SpinnerComponentUI
